var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.738 120C92.7304 120 119.476 93.1371 119.476 60C119.476 26.8629 92.7304 0 59.738 0C26.7456 0 0 26.8629 0 60C0 93.1371 26.7456 120 59.738 120Z",
    fill: "url(#paint0_linear_20_246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.738 49.6805C54.0029 49.6805 49.3366 54.3675 49.3366 60.1275C49.3366 65.8875 54.0029 70.5745 59.738 70.5745C65.4731 70.5745 70.1394 65.8877 70.1394 60.1275C70.1394 54.3673 65.4731 49.6805 59.738 49.6805ZM65.3695 59.5153L59.1285 65.7837C58.7222 66.1917 58.1899 66.3959 57.6577 66.3959C57.1254 66.3959 56.5931 66.192 56.1868 65.7837L54.1065 63.6942C53.294 62.8781 53.294 61.5558 54.1065 60.7397C54.919 59.9236 56.2356 59.9236 57.0481 60.7397L57.6577 61.3519L62.4276 56.561C63.2401 55.7449 64.5567 55.7449 65.3692 56.561C66.1817 57.3771 66.182 58.6992 65.3695 59.5153ZM84.7017 35.9768C73.187 35.9768 61.2536 25.2563 61.1337 25.1482C60.3414 24.4301 59.1345 24.4301 58.3423 25.1482C58.2224 25.2563 46.2892 35.9768 34.7743 35.9768C33.6245 35.9768 32.6939 36.9113 32.6939 38.0663V62.9496C32.6939 82.642 46.7501 90.5569 58.9964 95.254C59.2342 95.3459 59.486 95.3906 59.738 95.3906C59.99 95.3906 60.2418 95.3459 60.4796 95.254C72.7256 90.5569 86.782 82.642 86.782 62.9496V38.0663C86.7818 36.9113 85.8514 35.9768 84.7017 35.9768ZM59.738 74.7534C51.7093 74.7534 45.1759 68.1914 45.1759 60.1275C45.1759 52.0636 51.7093 45.5016 59.738 45.5016C67.7667 45.5016 74.3 52.0636 74.3 60.1275C74.3 68.1914 67.7667 74.7534 59.738 74.7534Z",
    fill: "url(#paint1_linear_20_246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_246",
    x1: 59.738,
    y1: -0.153132,
    x2: 59.738,
    y2: 117.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_246",
    x1: 32.6939,
    y1: 60.0001,
    x2: 91.2327,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.476,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance1);
export default __webpack_public_path__ + "static/media/insurance1.5d8161dcc687c93267a74665ad29a72c.svg";
export { ForwardRef as ReactComponent };